import { atomWithReset } from 'jotai/utils';

export const state = atomWithReset<{ [key: string]: any }>({
  userData: null,
  conditions: {
    termsAgree: false, // 약관 동의
    emailAuth: false, // 이메일 인증
    socialAccount: false, // 소셜 계정
    changePasswordRequest: false, // 비밀번호 변경 주기
    reIssueChangePassword: false, // 관리자에 의해 비밀 번호 변경
    responsibilityAuth: false, // 기존 직책코드 유지
    storeTransfer: false, // 매장 양도 이후 첫 로그인
  },
});
